import axios from "api/axios";

// App Backend
export const getUsageData = async () => {
  const response = await axios.get("/api/usage/");
  return response.data;
};
